import { useState, useEffect } from 'react'

/**
 * Devuelve la hora actual en ms como estado, refrescada cada `intervalMs`.
 *
 * Permite leer "ahora" durante el render de forma pura (es estado, no una
 * llamada a `Date.now()` en render, que el compilador de React marca como
 * impura) y que la UI reaccione al paso del tiempo —por ejemplo, reactivar
 * un botón cuando expira un cooldown—. El `setState` vive dentro del callback
 * del intervalo (asíncrono), así que no es un set-state-in-effect síncrono.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
